import { BlockType } from "../../types/block/type";

export interface OptimisticUpdate {
  id: number | string;
  data: BlockType;
  isNewBlock?: boolean;
  isDeletedBlock?: boolean;
}
class OptimisticBlockStore {
  private patches: Map<string, OptimisticUpdate> = new Map();

  add(patch: OptimisticUpdate) {
    // id나 clientId를 key로 사용 (isNewBlock이 undefined면 false로 처리)
    const key = patch.isNewBlock === true ? `${patch.data?.clientId || ""}` : String(patch.id);

    this.patches.set(key, patch);
  }

  remove({ id, clientId }: { id?: string | number; clientId?: string }) {
    if (id) {
      const key = String(id);
      this.patches.delete(key);
    } else if (clientId) {
      const key = `${clientId}`;
      this.patches.delete(key);
    }
  }

  getAll(): OptimisticUpdate[] {
    return Array.from(this.patches.values());
  }

  clear() {
    this.patches.clear();
  }
}

export const optimisticBlockStore = new OptimisticBlockStore();
